const module = { name: 'desktop/search/app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



import { default as pagination } from 'swug-fdRequire-call:desktop/shared/pagination';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as searchEvents } from 'swug-fdRequire-call:desktop/search/events';

function run() {
    checkDependencies(module.name, debugLog);
    pagination.attach({ bypassClientLoading: true });
    searchEvents.attach();
}
run();
export default module.exports;